import React, { useState, useContext, useRef, memo, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Login, Recaptchahandler } from '../../api/endpoints';
import ReCAPTCHA from 'react-google-recaptcha';
import './style.css';
import AuthWrapper from './components/authWrapper';
import ActionBtn from '../../component/ActionBtn';
import { Block } from '../../component/crRender';
import RememberMe from './components/rememberMe';
import useForm from '../../hooks/useForm';
import InputField from '../../component/formFields/InputField';
import { GetLocStorage, SetLocStorage } from '../../utils';
import { PrivilegeContext } from '../../context/PrivilegesContext';
import { DomainContext } from '../../context/DomainContext';

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITEKEY
const isRecaptchaEnabled = Boolean(recaptchaSiteKey)

const SignIn = () => {

    const [isHuman, setIsHuman] = useState(!isRecaptchaEnabled);

    const { setIsLoggedIn } = useContext(PrivilegeContext)
    const { setLoading } = useContext(DomainContext)
    
    const captchaRef = useRef(null);
    const email = useMemo(() => GetLocStorage("email"), [])
    const password = useMemo(() => GetLocStorage("password"), [])

    const { t, i18n } = useTranslation()
    const navigate = useNavigate()

    const { onSubmit, formHandler, formDataResult } = useForm()


    const handleSubmit = () => {
        setLoading(l => l + 1)
        Login(formDataResult, i18n.language).then(res => {
            SetLocStorage('ut', res.data.accessToken)
            SetLocStorage('rt', res.data.refreshToken)
            setIsLoggedIn(true)
            navigate('/panel')
        }).catch(() => {

        }).finally(() => setLoading(l => l - 1))
    }

    const recaptchahandler = () => {
        const token = captchaRef.current?.getValue()
        if (!token) {
            setIsHuman(false)
            return
        }
        const RecaptchaData = { token }

        Recaptchahandler(RecaptchaData).then(res => {
            setIsHuman(Boolean(res.data))
        }).catch(() => {
            setIsHuman(false)
        })
    }



    return (
        <AuthWrapper >
            <InputField isLoading={false} className={"col-md-12"} type={"email"} name={"email"} formHandler={formHandler} defaultValue={email} />
            <InputField isLoading={false} className={"col-md-12"} type={"password"} name={"password"} formHandler={formHandler} defaultValue={password} />

            <div className='forget-password-container'>
                <RememberMe dataObject={formDataResult} />
                <Link to='/ForgetPassword' className='forgetP-password-link'>{t("forgetPassword")}</Link>
            </div>

            <Block className={"recaptcha-container"} isRender={isRecaptchaEnabled}>
                <ReCAPTCHA className='recaptcha' sitekey={recaptchaSiteKey} ref={captchaRef} onChange={recaptchahandler} />
            </Block>

            <ActionBtn isDisabled={!isHuman} className={"login-btn"} onApply={() => onSubmit(handleSubmit)} title={"login"} />
        </AuthWrapper>

    );
}

export default memo(SignIn);

